module.exports = pricetemplates;